import { AppPaymentService } from './../../../services/AppRootService/app-payment.service';
import { Component, inject, OnDestroy, OnInit, signal, ViewChild } from "@angular/core";
import { IonicModule, ModalController, NavController } from "@ionic/angular";
// @ts-ignore
import { AsyncPipe, DatePipe, DecimalPipe, NgClass, NgIf, NgStyle } from "@angular/common";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { doc, docData, DocumentData, Firestore, getDoc } from "@angular/fire/firestore";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { formatDisplayCurrencyAmount } from "@core/currency-display.util";
import { LoadingService } from "@core/loading.service";
import { isMobile, UtilityService } from '@core/utility.service';
import { Popover } from "@interfaces/popover.enum";
import { CheckedPeriod } from "@interfaces/prize-breakdown";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { BehaviorSubject, combineLatest, Subscription } from "rxjs";
import { map, take, tap } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { AddHomeScreenComponent } from "src/app/components/add-home-screen/add-home-screen.component";
import { NewCountDownTimerComponent } from "src/app/components/new-count-down-timer/new-count-down-timer.component";
import { QuickAccessComponent } from "src/app/components/quick-access/quick-access.component";
import { SurpriseGiftSlideUpComponent } from "src/app/components/surprise-gift-slide-up/surprise-gift-slide-up.component";
import { BannerCacheService } from "src/app/services/banner-cache.service";
import { BreakdownBannerService } from "src/app/services/breakdown-banner.service";
import { CommonService } from "src/app/services/common/common.service";
import { resolveCreditWonAmount } from "../check-winnings-display";
import { GameBalanceService } from "src/app/services/game-balance.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { GamesFeedSampleService } from "../../games-feed-sample/games-feed-sample.service";
import { GamesRepositoryService } from "../../games/games-repository.service";
import { HomeRepositoryService } from "../../home/home-repository.service";
import { PrivateSyndicateRepositoryService } from "../../private-syndicate/private-syndicate.repository.service";
import { StoreRepositoryService } from "../../store/store-repository.service";
import { CheckedManagedTicketComponent } from "../../syndicate/tickets/checked-managed-ticket/checked-managed-ticket.component";
import { TabRepositoryService } from "../../tabs/tab-repository.service";
import { CheckWinningsRepositoryService } from "../check-winnings-repository.service";
import { ThumbAnimationComponent } from "../thumb-animation/thumb-animation.component";
import { VoucherCollectionComponent } from "../voucher-collection/voucher-collection.component";
import { VoucherService } from 'src/app/services/vouchers.service';
import { GameDatasService } from '../../games/services/game-data.service';

@Component({
  selector: "app-breakdown",
  templateUrl: "./breakdown.component.html",
  styleUrls: ["./breakdown.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    NgClass,
    MatExpansionPanelTitle,
    ThumbAnimationComponent,
    SwiperModule,
    InProgressAnimationComponent,
    AsyncPipe,
    DecimalPipe,
    DisplayCurrencyPipe,
    DatePipe,
    TranslatePipe,
    VoucherCollectionComponent,
    NgStyle,
    NgIf,
    NewCountDownTimerComponent
  ],
})
export class BreakdownComponent implements OnInit, OnDestroy {
  weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  calenderDays: any = [];
  lastWeek: any = [];
  nextSunday: Date = new Date();
  protected isBannerDisplay = signal<boolean>(false)
  protected bannerDisplayToggle = signal<boolean>(false)
  protected visibilityControl = signal<string>("");
  protected operatorSelection = signal<string>("");
  protected jackpotTriggerActiveCount = signal<number>(0);
  protected isCreditRefresh = signal<boolean>(false);
  private bannerIntervalId: ReturnType<typeof setInterval>;
  surpriseGift = "2 Euromillions lines";
  newCalendarDays: any = [];
  checkedPeriod: CheckedPeriod = {
    start_date: new Date(),
    end_date: new Date(),
  };
  calerndarPeriod = { start_date: new Date(), end_date: new Date() };
  getPrizeBreakdown$ = new BehaviorSubject(null);
  encrClaimEventId = null;
  show: boolean = false;
  show1: boolean;
  show2: boolean;
  touch$ = new BehaviorSubject(false);
  showAnimationForPoints: boolean = false;
  showAnimation: boolean = true;
  showGoldRings = false;
  cardBannerData: DocumentData = {};
  userPoints: number;
  description: string;
  matchedRange = null;
  autoSlide = signal(false);
  voucherService = inject(VoucherService)
  isVoucherTypeGeneral = signal(false);
  @ViewChild("storePageCardSlider") storeCardSlider: SwiperComponent;
  public lotteriesData: Data; // Store the user lottery details
  public numberOfLines: number; // Store Number for Lines
  count = 0;
  user$ = combineLatest([this.authService.userDetails$, this.touch$]).pipe(
    map(([user, touched]: any) => {
      if (!touched && this.count === 0 && user && user.onboard_state === "awareness") {
        this.count++;
        this.show = true;
        return;
      } else if (touched && this.count === 1 && user && user.onboard_state === "awareness") {
        this.count++;
        this.show = false;
        this.show1 = true;
      } else if (touched && this.count === 2 && user && user.onboard_state === "awareness") {
        this.count++;
        this.show = false;
        this.show1 = false;
        this.show2 = true;
      } else if (touched && this.count === 3 && user && user.onboard_state === "awareness") {
        this.count++;
        this.show = false;
        this.show1 = false;
        this.show2 = false;
      }
    })
  );
  winningToolTip = this.homeRepositoryService.toolTipText$;
  selectedLanguage: string;
  preferredCurrency: string = CommonVariable.preferredCurrency;
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  prizeDrawContent: string;
  luckyNumberBreakdown: any;
  languageCode: string = "en";
  prizeDrawEntries: string;
  replenished: string;
  slideData: Data[] = [];
  entriesDesc: string;
  replenishedDesc: string;
  remoteConfigLuckyNumber = false;
  public use_points: string;
  public prize_account$ = new BehaviorSubject('');
  public gift_url: string;
  public creditRefreshStatusSubscription: Subscription;
  public jackpotActivatedCountSubscription: Subscription;
  public voucherDataSubscription: Subscription;
  eventTrigger = signal<Data>([]);
  creditBreakdown: Data;
  banners: Data[];
  public userId: string;
  private refreshTimeoutId?: ReturnType<typeof setTimeout>;
  private static readonly REFRESH_DELAY_MS = 3000; // still configurable if needed
  constructor(
    private firestore: Firestore,
    private gameDatasService : GameDatasService,
    public gamesFeedService: GamesFeedSampleService,
    private bottomSheet: MatBottomSheet,
    private window: Window,
    private dialog: MatDialog,
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    private checkWinningsService: CheckWinningsRepositoryService,
    private router: Router,
    private storeService: StoreRepositoryService,
    private analytics: AngularFireAnalytics,
    private tabService: TabRepositoryService,
    private authService: AuthService,
    private homeRepositoryService: HomeRepositoryService,
    public translate: TranslateService,
    private luckyNumberService: LuckyNumberService,
    private jackpotTriggerService: JackpotTriggersService,
    private GTMSegment: GTMSagmentService,
    private privateSyndicateService: PrivateSyndicateRepositoryService,
    private gameBalanceService: GameBalanceService,
    private sanitizer: DomSanitizer,
    private breakdownBannerService: BreakdownBannerService,
    private commonService: CommonService,
    private bannerCacheService: BannerCacheService,
    private loadingService: LoadingService,
    private appPaymentService: AppPaymentService,
  ) {

    // credit refresh
    this.creditRefreshStatusSubscription = this.gameBalanceService?.isBreakDownCreditRefreshStatus$?.subscribe(
      (data: Data) => {
        // Defensive handling: ensure data is valid before accessing properties
        const isCreditValue = data && typeof data === 'object' ? data?.status : false;
        this.isCreditRefresh.set(isCreditValue ?? false);
      },
      (error) => {
        this.authService.errorHandlerLogs('Error in creditRefreshStatusSubscription:', error);
        this.isCreditRefresh.set(false);
      }
    );
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );

    this.authService.userDetails$?.subscribe(
      (user: any) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$.subscribe((data: any) => {
          const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      (err) => {
        return err;
      }
    );

    // this.analytics.logEvent("prize_breakdown_screen", { userId: this.userId});

    // jackpot trigger count
    this.jackpotActivatedCountSubscription = this.storeService?.jackpotActivatedCount$?.subscribe((count) => {
      this.jackpotTriggerActiveCount.set(count);
    });
  }
  // Slider
  storeSliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1.1,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination_",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
    },
    slideToClickedSlide: true,
  };
  // Slider
  shouldPauseAutoplay = false; // store swiper autoplay status
  swiperInstance: Swiper | null = null; // store swiper data
  interval: ReturnType<typeof setInterval> | undefined; // store time interval
  bannerInterval: ReturnType<typeof setTimeout> | undefined; // store time interval

  // This method is used to change the slider banner automatically after each 3 second of interval
  setSwiperInstance(swiper: Swiper | null) {
    this.swiperInstance = swiper;
    // Clear any existing intervals
    clearInterval(this.interval);
    // Start a new interval to check and control autoplay
    this.interval = setInterval(() => {
      if (this.swiperInstance && this.swiperInstance.params && this.swiperInstance.params.autoplay !== undefined) {
        if (!this.autoSlide()) {
          // If autoSlide is false, stop autoplay
          this.swiperInstance?.autoplay?.stop();
        } else {
          // If autoSlide is true, start or resume autoplay
          this.swiperInstance?.slideNext(400);
          this.swiperInstance?.autoplay?.start();
        }

      }
    }, 4500);
  }


  frameCalendar(startDate, endDate) {
    return new Promise((resolve, reject) => {
      const lastSunday = new Date(startDate);
      const nextSat = new Date(endDate);
      lastSunday.setDate(lastSunday.getDate() - lastSunday.getDay());
      let daycount = 0;
      for (daycount = 0; daycount < 8; daycount++) {
        if (nextSat.getDay() === 6) {
          break;
        }
        nextSat.setDate(nextSat.getDate() + 1);
      }
      const dates = {
        start: lastSunday,
        end: nextSat,
      };

      resolve(dates);
      this.calerndarPeriod.end_date = nextSat;
      this.calerndarPeriod.start_date = lastSunday;
      this.prepareCalender(lastSunday, nextSat);
    });
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("BreakdownComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("prize_breakdown_screen", { userId: this.userId });
      })
      .catch((error) => {
        return error;
      });
    // This method is call the getPromoCardtData
    this.fetchVouchersData();
    this.loadBreakdownBanners();
    this.getPromoCardtData();
    // This method is call the upsell slider
    setTimeout(() => {
      this.upsellSlider();
    }, 3000)
    let count = 0;
    this.bannerIntervalId = setInterval(() => {
      count = count + 1;
      if (count == 6) {
        this.showAnimation = false;
        this.showAnimationForPoints = false;
      }
    }, 1000);
    this.route.params.subscribe(
      (data) => {
        this.checkWinningsService
          .getBreakDown(data.id)
          .pipe(
            tap((data: any) => {
              if (data.credit_won != true && data.gift_won != true && data.points_won == true) {
                this.showAnimationForPoints = true;
              }
              if (!data || !data.check_period_start || !data.check_period_end) return;
              this.encrClaimEventId = data?.encr_claim_event_id;
              this.checkedPeriod.start_date = data.check_period_start.toDate();
              this.checkedPeriod.end_date = data.check_period_end.toDate();
              this.newCalendarDays = [];
              this.frameCalendar(this.checkedPeriod.start_date, this.checkedPeriod.end_date).then(() => { });
            })
          )
          .subscribe(
            (data) => {
              this.gift_url = data.gift_url;
              this.getPrizeBreakdown$.next(data);
            },
            (err) => {
              return err;
            }
          );
      },
      (err) => {
        return err;
      }
    );

    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe((data) => {
        this.luckyNumberBreakdown = data?.["lucky_number_breakdown"];
        this.weekdays = data?.["DAYS"];
        this.prizeDrawEntries = this.luckyNumberBreakdown?.prize_draw_entries;
        this.replenished = this.luckyNumberBreakdown?.replenished;
        this.entriesDesc = this.luckyNumberBreakdown?.entries_desc;
        this.replenishedDesc = this.luckyNumberBreakdown?.replenished_desc;
        if (this.entriesDesc) {
          this.authService
            .getDVFromString(this.entriesDesc)
            .then((dvString: string) => {
              if (dvString) {
                this.prizeDrawContent = dvString;
              } else {
                return "";
              }
            })
            .catch((err) => {
              return err;
            });
        }
      });
      // This methode has been used to call bannerData
      this.bannerData();
      // This methode has been used to get prize breakdown
      this.translate.get(['breakdown.prize_account', 'breakdown.Use_points']).subscribe(async (translations) => {
        this.getPrizeBreakdown$.subscribe(async (data) => {
          const shortDescription = data?.gift_won_details?.short_description;
          const giftWonPrize = shortDescription ? await this.currencyConversion(shortDescription) : data?.gift_won;
          if (data) {
            const prize = await translations["breakdown.prize_account"].replace("[gift_name]", giftWonPrize);
            this.prize_account$.next(prize);
            const sources = data?.preferred_currency?.total_credit?.sources?.length
              ? data.preferred_currency.total_credit.sources
              : data?.base_currency?.total_credit?.sources || [];
            // Optional: map sources into a format for display if needed
            this.creditBreakdown = sources
              ?.filter((source: Data) => source?.value > 0)
              .map((source: Data) => ({
                label: this.getLabel(source?.type),
                value: `${this.currencySymbol}${formatDisplayCurrencyAmount(source?.value)}`
              }));
          }
        })
        await this.authService
          .getDVFromString(translations['breakdown.Use_points'])
          .then(async (dvString: string) => {
            this.use_points = dvString;
          }).catch((error) => {
            return error;
          });
      });
    });
    try {
      this.gamesFeedService?.getRapidFireDetails$?.subscribe((ref: Data) => {
        this.userPoints = ref[0]?.data && ref[0]?.data?.points;
        // used to call the banner data
        this.bannerData();
      },
        (error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  }

  async bannerData() {
    return new Promise((resolve, reject) => {
      const bannerDocRef = doc(this.firestore, `/Global_lookup/breakdown_game_banner`);
      getDoc(bannerDocRef)
        .then(async (data) => {
          try {
            const docData = data?.data();
            this.cardBannerData = docData;
            const bannerVal = Object.values(this.cardBannerData);

            const foundMatch = bannerVal.some((ele: any) => {
              const gameIds = Object.keys(ele);
              gameIds.map((gameType) => {
                const game = ele[gameType];
                const min = game.range.min;
                const max = game.range.max;
                const image_url = game.game_image_url;
                const prize = game.top_prize;
                const destination = game.destination;
                const content = game.content;
                const top_prize = game.top_prize;

                // Extract currency_beautify value from top_prize
                const currencyValue = this.extractCurrencyValue(prize);

                if (this.userPoints >= min && this.userPoints <= max) {
                  this.matchedRange = {
                    min,
                    max,
                    image_url,
                    prize: currencyValue,
                    destination,
                    content,
                    top_prize,
                  };
                  return true; // Stop iteration once a match is found
                }
                return false;
              });

              if (this.matchedRange !== null) {
                const pattern = /\[currency_node:top_prize\]/;
                let topPrize = this.matchedRange.content[
                  this.selectedLanguage
                ].description.replace(pattern, this.matchedRange.top_prize);
                Promise.all([
                  this.authService
                    .getDVFromString(topPrize)
                    .then(async (dvString: string) => {
                      this.description = dvString;
                    }),
                  this.authService
                    .getDVFromString(this.matchedRange.top_prize)
                    .then((dvString: string) => {
                      this.matchedRange.prize = dvString;
                    }),
                ])
                  .then(() => {
                    resolve(this.matchedRange); // Resolved with matched range
                  })
                  .catch((err) => {
                    reject(err);
                  });
                return true;
              }

              return false;
            });

            if (!foundMatch) {
              resolve(null); // Resolved with null if no match was found
            }
          } catch (error) {
            reject(error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  extractCurrencyValue(prize: string): number | null {
    const regex = /\[currency_beautify:(\d+)\]/;
    const match = prize.match(regex);

    if (match && match.length > 1) {
      const valueStr = match[1];
      const value = parseInt(valueStr, 10);
      return value;
    }
    return null;
  }

  goBack() {
    this.navCtrl.back();
  }

  isCheckDateAnimation(date: Date, allDates: Data[]) {
    if (!allDates) {
      return false;
    }
    const indexToCheck = allDates?.length - 1;
    return allDates.some((x, index) => {
      if (x && x.checked_date) {
        return (
          this.withoutTime(x.checked_date?.toDate()).toDateString() === this.withoutTime(date).toDateString() &&
          index === indexToCheck
        );
      }
    });
  }

  isWinningDateAnimation(date: Date, allDates: Data[]) {
    const indexToCheck = allDates?.length - 1;

    if (!allDates) {
      return false;
    }

    return allDates.some((x, index) => {
      if (x && x.checked_date) {
        return (
          this.withoutTime(x.checked_date?.toDate()).toDateString() === this.withoutTime(date).toDateString() &&
          x.win_status === "win" &&
          index === indexToCheck
        );
      }
    });
  }

  isWinningDate(date: any, allDates: any[]) {
    if (!allDates) {
      return false;
    }

    return allDates.some((x) => {
      if (x && x.checked_date) {
        return (
          this.withoutTime(x.checked_date?.toDate()).toDateString() === this.withoutTime(date).toDateString() &&
          x.win_status === "win"
        );
      }
    });
  }

  isCheckDate(date: any, allDates: any[]) {
    if (!allDates) {
      return false;
    }
    return allDates.some((x) => {
      if (x && x.checked_date) {
        return this.withoutTime(x.checked_date?.toDate()).toDateString() === this.withoutTime(date).toDateString();
      }
    });
  }

  withoutTime(date: any) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  getCalanderDate(date, allDates: any[]) {
    if (!allDates) return;
    return allDates?.find((x) => {
      if (x && x.checked_date) {
        return this.withoutTime(x.checked_date?.toDate()).toDateString() === this.withoutTime(date).toDateString();
      }
    });
  }

  /* To the Dynamic calender */
  prepareCalender(startDate: Date, endDate: Date) {
    let dayOfTheWeek = 0;
    let addOneMoreWeek: boolean;
    let weekCycle: any = [];
    let previousMonth = startDate.getMonth();
    let currentMonth = endDate.getMonth();
    let isRepeating = false;
    const hiddenDays = [1, 2, 3, 4, 5, 6, 7];
    const currentDate: Date = startDate;

    let weekCycleObj: any = [];

    const diff = Math.abs(startDate.getTime() - endDate.getTime());
    let count = Math.ceil(diff / (1000 * 3600 * 24)) + 1;

    for (dayOfTheWeek = 0; dayOfTheWeek < count; dayOfTheWeek++) {
      if (currentDate.getDate() === 8 && addOneMoreWeek) {
        count = count + 7;
        currentDate.setDate(1);
        addOneMoreWeek = false;
        isRepeating = true;
      }

      const dateDetails = {
        date: new Date(currentDate),
        visibility: true,
        repeat: isRepeating,
      };

      weekCycle.push(new Date(currentDate));
      weekCycleObj.push(dateDetails);
      if (currentDate.getDay() === 6) {
        this.calenderDays.push(weekCycle);
        this.newCalendarDays.push(weekCycleObj);
        weekCycle = [];
        weekCycleObj = [];
      }
      previousMonth = currentDate.getMonth();
      currentDate.setDate(currentDate.getDate() + 1);
      currentMonth = endDate.getMonth();
    }

    if (endDate.getDay() === 6) {
      this.nextSunday = new Date(currentDate);
      /* push one more week */
      weekCycle = [];
      for (dayOfTheWeek = 0; dayOfTheWeek < 7; dayOfTheWeek++) {
        weekCycle.push(new Date(currentDate));
        if (currentDate.getDay() === 6) {
          this.lastWeek.push(weekCycle);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
  }

  isDayNotInRange(day: any) {
    return !(
      day.getTime() < this.checkedPeriod.start_date.getTime() || day.getTime() > this.checkedPeriod.end_date.getTime()
    );
  }

  isStartDate(dateNumber: any) {
    return dateNumber.getTime() === this.checkedPeriod.start_date.getTime();
  }

  isEndDate(dateNumber: any) {
    return dateNumber.getTime() === this.checkedPeriod.end_date.getTime();
  }

  async openCheckedTickets(detail: any, winningDates: any) {
    const checkTicketDate = this.getCalanderDate(detail.date, winningDates);
    if (checkTicketDate) {
      const checkedTickets = await this.modalCtrl.create({
        component: CheckedManagedTicketComponent,
        cssClass: "modal-fullScreen",
        // enterAnimation: CustomAnimation.enterFromRight,
        // leaveAnimation: CustomAnimation.exitThroughRight,
        componentProps: {
          checkDate: checkTicketDate.checked_tickets,
          detail: detail,
          id: this.encrClaimEventId,
          claimEventId: this.route.snapshot.params.id,
        },
      });
      return await checkedTickets?.present();
    }
  }

  getClickedDate(dateClicked, winningDates) {
    if (!winningDates) return;
    return winningDates?.find((x) => x?.toDate().getTime() === dateClicked.getTime()).check_date;
  }

  isAfterNextSunday(calendarDate: any) {
    return calendarDate.getTime() > this.nextSunday.getTime();
  }

  isEndDateSaturday() {
    return this.checkedPeriod.end_date.getDay() === 6;
  }

  isInVisibleDate(calendarDate: any) {
    const maxVisibilityDate: Date = new Date(this.calerndarPeriod.end_date);
    maxVisibilityDate.setDate(maxVisibilityDate.getDate() + 1);
    return maxVisibilityDate.getTime() < calendarDate.getTime();
  }

  isFirstdayOfMonth(date: any) {
    return date.getDate() === 1;
  }

  isLastDayOfMonth(date: any) {
    const month = date.getMonth();
    const year = date.getFullYear();
    const lastDate = new Date(year, month + 1, 0);
    return lastDate.getTime() === date.getTime();
  }

  getClaimCheckDate(claimDate: any) {
    if (!claimDate) return;
    return claimDate.toDate();
  }

  navigateToStore() {
    this.tabService.selectStoreTab();
    this.router.navigateByUrl("mainTabs/tabs/store");
  }

  navigateToGames() {
    this.tabService.selectGameTab();
    this.router.navigateByUrl("mainTabs/tabs/game");
  }

  navigateToCashout() {
    this.router.navigateByUrl("cashout");
  }

  backTpSyndicate() {
    this.tabService.selectSyndicateTab();

    if (isMobile.iOS()) {
      this.checkIfUserIsOnStandAlone();
    } else if (isMobile.Android()) {
      this.addHomeScreen();
    }

    this.router.navigateByUrl("mainTabs/tabs/syndicate");
  }
  // The addHomeScreen method is used to  add-home-screen-bottomSheet on addHomeScreen
  addHomeScreen() {
    const popupShown = this.authService.safeGetItem(Popover.popupShown) === Popover.isTrue;
    if (UtilityService.isAppInstalledOnHomePage() || popupShown) {
      return;
    }
    if (this.window["customEvent"]) {
      const addHomeScreen = this.bottomSheet.open(AddHomeScreenComponent, {
        panelClass: "add-home-popup-bottomSheet",
      });

      addHomeScreen?.afterDismissed()?.subscribe((data) => {
        if (data) {
          this.window["customEvent"].prompt();
          this.window["customEvent"].userChoice.then();
        }
      });
      this.authService.safeSetItem(Popover.popupShown, Popover.isTrue);
    }
  }
  // The checkIfUserIsOnStandAlone method is used to check if the user is using IOS
  checkIfUserIsOnStandAlone() {
    const popupShown = this.authService.safeGetItem('syndicatePopupShown');
    if (UtilityService.isAppInstalledOnHomePage() || popupShown === 'true') {
      return
    } else {
      if (isMobile.iOS()) {
        if (
          navigator.vendor &&
          navigator.vendor?.indexOf("Apple") > -1 &&
          navigator.userAgent &&
          navigator.userAgent?.indexOf("CriOS") == -1 &&
          navigator.userAgent?.indexOf("FxiOS") == -1
        ) {
          this.authService?.userDetails$?.pipe(take(1))?.subscribe((data: Data) => {
            if (!data.installed_last_auto_login_date) {
              setTimeout(() => {
                this.quickAccess();
              }, 5000);
              return;
            }
            if (!data || !data.installed_last_auto_login_date) return;
            let today = moment();
            let past = moment(data.installed_last_auto_login_date.toDate()).format();
            let gap = today.diff(past, "days");

            if (gap > 14) {
              setTimeout(() => {
                this.quickAccess();
              }, 5000);
            }

            return;
          });
        } else {
          /* const msg = this.translatedToastMsg?.["1043"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "Code Error", "Success", ""); */
          this.authService.getConstantsMsg(Popover.Id_1043).then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "The app works best on Safari browser",
                line_2: "",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }).catch((error) => {
            return error;
          });
        }
      }
      this.authService.safeSetItem("syndicatePopupShown", "true");
    }
  }
  navigateToHome() {
    this.router.navigateByUrl("mainTabs/tabs/home");
  }
  navigateToPrizeDraw() {
    this.router.navigateByUrl(`mainTabs/tabs${this.gift_url}`);
    this.luckyNumberService.loadPrizeDrawCard$.next(true);
  }

  isFirstDateWinningDate(date: any, checkedTicketDates: any[]) {
    /* To check whether the first date of the range is winning date */
    const isStartingDate = this.isStartDate(date);
    const isWinningDate = this.isWinningDate(date, checkedTicketDates);
    const isStartDateIsWinningDate = isStartingDate && isWinningDate ? true : false;
    return isStartDateIsWinningDate;
  }

  isLastDateWinningDate(date: any, winningDates: any[]) {
    /* To check whether the last date of the range is winning date */
    const isendingDate = this.isEndDate(date);
    const isWinningDate = this.isWinningDate(date, winningDates);
    const isLastDateIsWinningDate = isendingDate && isWinningDate ? true : false;
    return isLastDateIsWinningDate;
  }

  checkWinningDateInDateRange(date: any, winningDates: any[]) {
    if (this.isWinningDate(date, winningDates)) {
      let compareDate = moment(date);
      let startDate = moment(this.checkedPeriod.start_date);
      let endDate = moment(this.checkedPeriod.end_date);
      if (
        !(compareDate.isBetween(startDate, endDate) || compareDate.isSame(startDate) || compareDate.isSame(endDate))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  touch() {
    this.touch$.next(true);
  }
  quickAccess() {
    this.bottomSheet.open(QuickAccessComponent, {
      panelClass: "quick-popup-bottomSheet",
    });
  }
  // Upsell Slider Functionality
  upsellSlider() {
    try {
      this.commonService.getUid("UpsellSlider").subscribe((userId) => {
        if (!userId) {
          console.warn("[upsellSlider] ⚠️ No userId found, skipping balance fetch.");
          return;
        }

        // Get Balance Details
        this.authService
          .getAngularFireStore(`/users/${userId}/balance/current`, "snapshotChanges")
          .pipe(map((res: Data) => res && res?.data()))
          .subscribe((balance: Data) => {
            if (balance !== undefined && balance !== null) {
              let balanceAmount = balance?.preferred_currency?.credit;
              this.authService.safeSetItem("userCredit", balanceAmount);

              if (balanceAmount >= 0.40) {
                this.numberOfLines = Math.min(Math.floor(balanceAmount / 0.40), 10);

                this.privateSyndicateService.getSyndicateLotteries$
                  .pipe(
                    map((lotteries) => {
                      if (!Array.isArray(lotteries)) return [];

                      const currentDate = new Date();

                      const lotteriesExpiringToday = lotteries.filter((lottery) => {
                        if (!lottery?.jackpot?.expiry_date) return false;
                        const expiryDate = new Date(lottery?.jackpot?.expiry_date.seconds * 1000);
                        return (
                          expiryDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
                          expiryDate.getUTCMonth() === currentDate.getUTCMonth() &&
                          expiryDate.getUTCDate() === currentDate.getUTCDate()
                        );
                      });

                      const units = { K: 1_000, M: 1_000_000, B: 1_000_000_000 };

                      const sortedByPrize = lotteriesExpiringToday
                        .filter((lottery) => lottery?.id !== "RapidFire")
                        .sort((a, b) => {
                          // Access the int_jackpot_value property of the preferred currency
                          const currencyA = a?.jackpot?.int_jackpot_value?.[this.preferredCurrency];
                          const currencyB = b?.jackpot?.int_jackpot_value?.[this.preferredCurrency];

                          // Extract the jackpot values and units
                          const jackpotA = parseFloat(currencyA);
                          const jackpotB = parseFloat(currencyB);
                          const unitA = typeof currencyA === 'string' ? currencyA?.slice(-1) : '';
                          const unitB = typeof currencyB === 'string' ? currencyB?.slice(-1) : '';

                          // Define a map of units to their corresponding multipliers
                          const units = { K: 1000, M: 1000000, B: 1000000000 };

                          // Convert the jackpot values to a common unit for comparison
                          const valueA = jackpotA * (units[unitA] || 1);
                          const valueB = jackpotB * (units[unitB] || 1);

                          // Compare the jackpot values
                          return valueB - valueA; // Sort in descending order of jackpot value
                        });

                      const biggestPrizeLottery = sortedByPrize[0];

                      const filteredLotteries = lotteries.filter(
                        (lottery) =>
                          lottery?.real_name !== "PowerBall" &&
                          lottery?.real_name !== "RapidFire" &&
                          lottery?.real_name !== "Megamillions" &&
                          lottery?.real_name !== biggestPrizeLottery?.real_name
                      );

                      const sortedLotteries = filteredLotteries.sort((a, b) => {
                        const currencyA = a?.jackpot?.int_jackpot_value?.[this.preferredCurrency] || { amount: 0 };
                        const currencyB = b?.jackpot?.int_jackpot_value?.[this.preferredCurrency] || { amount: 0 };

                        // Extract the jackpot values and units
                        const jackpotA = parseFloat(currencyA);
                        const jackpotB = parseFloat(currencyB);
                        if (!currencyA && !currencyB) return;
                        const unitA = typeof currencyA === "string" ? currencyA?.slice(-1) : "";
                        const unitB = typeof currencyB === "string" ? currencyB?.slice(-1) : "";

                        // Define a map of units to their corresponding multipliers
                        const units = { K: 1000, M: 1000000, B: 1000000000 };

                        // Convert the jackpot values to a common unit for comparison
                        const valueA = jackpotA * (units[unitA] || 1);
                        const valueB = jackpotB * (units[unitB] || 1);

                        // Compare the jackpot values
                        return valueB - valueA; // Sort in descending order of jackpot value
                      });

                      const nextBiggestPrizeLotteries = sortedLotteries.slice(0, 1);
                      this.lotteriesData = [
                        ...this.slideData,
                        biggestPrizeLottery,
                        ...nextBiggestPrizeLotteries,
                      ];
                    })
                  )
                  .subscribe();
              }
            }
          });

        // ── modular-SDK: live balance/current doc stream
        docData(doc(this.firestore, `users/${userId}/balance/current`))
          .pipe(map((balance: any) => balance ?? null))
          .subscribe((balance: any) => {
            if (balance === null) return;

            const balanceAmount = balance?.preferred_currency?.credit;
            this.authService.safeSetItem("userCredit", balanceAmount);

            if (balanceAmount >= 0.4) {
              this.numberOfLines = Math.min(Math.floor(balanceAmount / 0.4), 10);

              this.privateSyndicateService.getSyndicateLotteries$
                .pipe(
                  map((lotteries) => {
                    if (!Array.isArray(lotteries)) return [];

                    const currentDate = new Date();

                    const lotteriesExpiringToday = lotteries.filter((lottery) => {
                      const seconds = lottery?.jackpot?.expiry_date?.seconds;
                      if (!seconds) return false;
                      const expiryDate = new Date(seconds * 1000);
                      return (
                        expiryDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
                        expiryDate.getUTCMonth() === currentDate.getUTCMonth() &&
                        expiryDate.getUTCDate() === currentDate.getUTCDate()
                      );
                    });

                    const units = { K: 1_000, M: 1_000_000, B: 1_000_000_000 };

                    const sortedByPrize = lotteriesExpiringToday
                      .filter((lottery) => lottery?.id !== "RapidFire")
                      .sort((a, b) => {
                        const curA = a?.jackpot?.int_jackpot_value?.[this.preferredCurrency] ?? "0";
                        const curB = b?.jackpot?.int_jackpot_value?.[this.preferredCurrency] ?? "0";
                        const valA = parseFloat(curA) * (units[curA.slice(-1)] || 1);
                        const valB = parseFloat(curB) * (units[curB.slice(-1)] || 1);
                        return valB - valA;
                      });

                    const biggestPrizeLottery = sortedByPrize[0];

                    const filteredLotteries = lotteries.filter(
                      (lottery) =>
                        lottery?.real_name !== "PowerBall" &&
                        lottery?.real_name !== "RapidFire" &&
                        lottery?.real_name !== "Megamillions" &&
                        lottery?.real_name !== biggestPrizeLottery?.real_name
                    );

                    const sortedLotteries = filteredLotteries.sort((a, b) => {
                      const curA = a?.jackpot?.int_jackpot_value?.[this.preferredCurrency] ?? "0";
                      const curB = b?.jackpot?.int_jackpot_value?.[this.preferredCurrency] ?? "0";
                      const valA = parseFloat(curA) * (units[curA.slice(-1)] || 1);
                      const valB = parseFloat(curB) * (units[curB.slice(-1)] || 1);
                      return valB - valA;
                    });

                    const nextBiggestPrizeLotteries = sortedLotteries.slice(0, 1);
                    this.lotteriesData = [
                      ...this.slideData,
                      biggestPrizeLottery,
                      ...nextBiggestPrizeLotteries,
                    ];
                  })
                )
                .subscribe();
            }
          });
      });
    } catch (error) {
      console.error("[upsellSlider] error:", error);
    }
  }


  // Lotteries Button
  upsellOfferCta(productName, numberOfLines) {

    // Set the Product Name and number of Lines in localStroage
    this.authService.safeSetItem("numberOfLines", numberOfLines);
    this.authService.safeSetItem("productName", productName);
    const body = {
      TP1: this.authService.safeGetItem("userCredit", "0"),
      TP2: productName + '_' + numberOfLines + '_lines',
    };
    // The event is fired when the user click the upsell slide.
    this.GTMSegment?.GTMEventPopupInitialization("Upsell Offer Click", body);
    this.GTMSegment?.GTMEventPopupInitialization("Upsell Offer View", body);
    // Redirect to a product pages.
    setTimeout(() => {
      this.router.navigate([`/store/products/${productName}`], {
        queryParams: {
          useCredit: 'yes',
          numberOfLines: numberOfLines.toString()
        }
      });
    }, 2000)
  }

  // method to redirect from game card button
  redirectToGame(destination) {
    setTimeout(() => {
      this.router.navigate([destination]); // Navigate to the destination
    }, 2000)
  }

  // Method to fetch promotional card data and set up slide data for display
  getPromoCardtData() {
    try {
      // Call the service to get promo card data
      const userId = this.userId;
      this.checkWinningsService.getPromoCardtDataSlideData(userId).subscribe({
        // Handle successful data retrieval
        next: (data: Data) => {
          data = data?.data;
          const slidesData = data;
          // Set the card type to 'promo_card' for all retrieved slide data
          slidesData["card_type"] = "promo_card";
          // Sanitize background if present
          if (data?.background) {
            const cleaned = data?.background?.replace(/\u00A0/g, ' ');
            data.background = this.sanitizer?.bypassSecurityTrustStyle(cleaned);
          }
          this.autoSlide.set(data?.auto_slide);
          this.bannerDisplayToggle.set(data?.display_banner);
          this.isBannerDisplay.set(data?.display_banner);
          this.visibilityControl.set(data?.visibility_control);
          this.operatorSelection.set(data?.operator_selection);
          this.eventTrigger.set(data?.event_trigger);
          // Ensure slideData is an array for consistent processing
          this.slideData = Array.isArray(slidesData) ? slidesData : [slidesData];
          // Apply visibility logic based on operators and selected events
          this.applyVisibilityControl();
        },
      });
    } catch (error) {
      return error;
    }
  }
  // Apply visibility logic based on operators and selected events
  applyVisibilityControl(): void {
    const visibility = this.visibilityControl();
    const operator = this.operatorSelection();
    const eventTrigger = this.eventTrigger();
    const isTriggerMissing = !operator && eventTrigger?.length === 0;

    if (visibility === "show") {
      this.isBannerDisplay.set(
        isTriggerMissing
          ? true
          : operator === "AND"
            ? this.checkBothActionsActive()
            : this.checkAnyActionActive()
      );
    } else if (visibility === "hide") {
      this.isBannerDisplay.set(
        isTriggerMissing
          ? false
          : operator === "AND"
            ? !this.checkBothActionsActive()
            : !this.checkAnyActionActive()
      );
    }
  }


  /** Helper functions to check event triggers */
  checkBothActionsActive(): boolean {
    // Implement logic to check if both actions are active
    return this.jackpotTriggerActiveCount() && this.isCreditRefresh();
  }
  checkAnyActionActive(): boolean {
    // Check if jackpotTriggerActiveCount is greater than 0
    return this.jackpotTriggerActiveCount() > 0 || this.isCreditRefresh();
  }

  // method to redirect from game card button
  redirectToPromoURL(ctaUrl: string, jackpotValue?: string, bannerType?: string) {
    if (jackpotValue) {
      this.appPaymentService.jackpotValueSignal.set(jackpotValue);
    }
    if (bannerType === 'voucher') {
       this.appPaymentService.isVoucherClaimed.set(true);
    }
    if (ctaUrl?.startsWith("http")) {
      window.location.href = ctaUrl;
    } else {
      this.router.navigateByUrl(ctaUrl);
    }
  }

  // Opens the Surprise Gift Slide Up component.
  // It fetches the gift data based on the provided checkWinningsGift parameter and displays it in a slide-up modal.
  openSlideUp(checkWinningsGift: string) {
    this.checkWinningsService.getCheckWinningsGift(checkWinningsGift).subscribe((res: Data) => {
      // If no data is returned, exit the function
      if (!res) return;
      // Opens the bottom sheet modal with the SurpriseGiftSlideUpComponent and binds the response data to it
      this.bottomSheet.open(SurpriseGiftSlideUpComponent, {
        disableClose: true,
        data: res,
      });
    });
  }

  // Converts a currency placeholder within a string to its actual currency value.
  async currencyConversion(value) {
    // If the currency placeholder is absent, return the value as is
    if (value.indexOf("[currency_beautify:") === -1) return value;

    // Extracts the placeholder and retrieves the corresponding currency value
    const startIndex = value.indexOf("[currency_beautify:");
    const endIndex = value.indexOf("]", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      const currencySubstring = value.substring(startIndex, endIndex + 1);

      // Fetches the converted currency value asynchronously
      const currencyValue = await this.gameDatasService.getDVCurrency(currencySubstring);

      // Replaces the placeholder with the actual currency value in the HTML string
      const htmlevalue = value.replace(currencySubstring, currencyValue);
      return htmlevalue
      // Updates the giftValue with the formatted currency string
    }
  }
  // Method to unsubscribe from observables
  ngOnDestroy(): void {
    if (this.bannerIntervalId) {
      clearInterval(this.bannerIntervalId);
    }
    if(this.interval) {
      clearInterval(this.interval);
    }
    this.creditRefreshStatusSubscription.unsubscribe();
    this.jackpotActivatedCountSubscription.unsubscribe();
    // Unsubscribe from voucher data subscription to prevent memory leaks
    this.voucherDataSubscription?.unsubscribe();
    if (this.refreshTimeoutId) clearTimeout(this.refreshTimeoutId);
  }

  getLabel(type: string): string {
    const labels: Record<string, string> = {
      lottery_win: 'breakdown.lotteryWin',
      lucky_dip: 'breakdown.luckyDip',
      gifted_credit: 'breakdown.giftedCredit'
    };

    return labels[type] || type;
  }

  getCreditWonAmount(prizeBreakdown: Data): number {
    return resolveCreditWonAmount(prizeBreakdown);
  }

  loadBreakdownBanners(): void {
    this.loadingService.present()
    const userId = this.userId;
    this.breakdownBannerService.getBreakdownBanners(userId).subscribe({
      next: (banners) => {
        this.loadingService.dismiss();
        this.banners = banners;
        this.bannerCacheService.setCachedBanners(userId, banners);
      },
      error: (err) => {
        this.loadingService.dismiss();
        this.banners = [];
        return err;
      }
    });
  }

  getBackgroundStyle(background: string): { [klass: string]: string } {
    if (!background) return {};

    const isGradient = background?.startsWith('linear-gradient');
    const isImageUrl = background?.startsWith('http') || background.startsWith('https');

    if (isGradient) {
      return { background };
    } else if (isImageUrl) {
      return {
        backgroundImage: `url(${background})`,
      };
    }

    // Fallback if not a gradient or image
    return { background };
  }

  trackBannerClick(banner: Data) {
    this.GTMSegment?.trackBannerClick("banner_click", {
      'banner_type': banner?.type,
      'banner_priority': banner?.priority,
      'user_id': `${this.userId}`
    });
  }
  getAllSlides(): Data[] {
    return [...(this.slideData || []), ...(this.banners || [])];
  }

  onVoucherClaimed(): void {
    if (this.refreshTimeoutId) {
      clearTimeout(this.refreshTimeoutId);
    }
    this.refreshTimeoutId = setTimeout(() => {
      this.loadBreakdownBanners();
      this.refreshTimeoutId = undefined;
    }, BreakdownComponent.REFRESH_DELAY_MS);
    this.appPaymentService.isVoucherClaimed.set(true);
  }
// This method has been use to cerate a voucher data and check whether the voucher is general or not. 
// If the voucher is general then it will set the isVoucherTypeGeneral signal to true otherwise it will set to false.
private fetchVouchersData() {
  this.voucherDataSubscription = this.voucherService.getVoucherList().subscribe({
    next: (res: Data[]) => {
      const now = Date.now();
      const filteredVouchers = res.filter(v =>
        v?.discount_voucher &&
        !v?.isRedeemed &&
        !v?.hide &&
        v?.expiry_date?.toDate()?.getTime() > now
      );
      // ✅ Check if any voucher is 'general'
      const hasGeneral = filteredVouchers.some(v => v?.supplier?.toLowerCase() === "general");
      this.isVoucherTypeGeneral.set(hasGeneral); // true or false
    },
    error: err => {
      // Log the error and handle it gracefully, ensuring the app remains stable even if voucher data fails to load
      return this.authService.errorHandlerLogs("fetch Vouchers Data Error", err);
    },
  });
}
  
}
